<template>
  <div>
    <div class="overflow-auto">
      <ts-loading-banner :loading="waiting">
        <table id="table-details">
          <thead>
            <tr>
              <th class="ts-whitespace-no-wrap" style="width:200px">
                {{ $t('invoice.feeType') }}
              </th>
              <th class="ts-whitespace-no-wrap" style="width:200px">
                {{ $t('invoice.feeName') }}
              </th>
              <th class="ts-whitespace-no-wrap" style="width: 140px;">
                {{ $t('invoice.dateFrom') }}
              </th>
              <th class="ts-whitespace-no-wrap" style="width: 140px;">
                {{ $t('invoice.dateTo') }}
              </th>
              <th class="ts-whitespace-no-wrap" style="width: 70px;">
                {{ $t('invoice.qty') }}
              </th>
              <th class="ts-whitespace-no-wrap" style="width: 99px;">
                {{ $t('invoice.fee') }}
              </th>
              <th class="ts-whitespace-no-wrap" style="width:90px">
                {{ $t('invoice.discountType') }}
              </th>
              <th class="ts-whitespace-no-wrap" style="width: 94px;">
                {{ $t('invoice.discount') }}
              </th>
              <th class="ts-whitespace-no-wrap" style="width: 81px;">
                {{ $t('invoice.vat') }}(%)
              </th>
              <th class="ts-whitespace-no-wrap" style="width: 120px;">
                {{ $t('invoice.amount') }}
              </th>
              <th style="width:1%">
                <a href="#" class="text-primary" @click.prevent="addRow">
                  <i class="fa fa-plus"></i>
                </a>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(detail, index) in model.inv_detail_list" :key="index">
              <td valign="top">
                <a-select
                  v-model.number="detail.fee_type_id"
                  style="width: 100%"
                  :options="feeTypesList"
                  @change="fetchFeeSetupDetail(detail)"
                  :disabled="!disableSelect"
                />
                <div
                  class="validate"
                  v-if="errors.has('inv_detail_list.' + index + '.fee_type_id')"
                >
                  {{
                    errors.first('inv_detail_list.' + index + '.fee_type_id')
                  }}
                </div>
              </td>
              <td valign="top">
                <a-select
                  v-model.number="detail.fee_setup_id"
                  style="width:100%"
                  :showSearch="true"
                  :options="feeSetupDetail(detail)"
                  :disabled="!disableSelect"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  optionFilterProp="children"
                  @change="onFeeSetupChange(detail)"
                />
                <div
                  class="validate"
                  v-if="
                    errors.has('inv_detail_list.' + index + '.fee_setup_id')
                  "
                >
                  {{
                    errors.first('inv_detail_list.' + index + '.fee_setup_id')
                  }}
                </div>
              </td>
              <td valign="top">
                <a-date-picker
                  placeholder="Date From"
                  valueFormat="DD-MM-YYYY"
                  format="DD-MM-YYYY"
                  v-model="detail.fee_start_date"
                  style="width: 100%"
                />
                <div
                  class="validate"
                  v-if="
                    errors.has('inv_detail_list.' + index + '.fee_start_date')
                  "
                >
                  {{
                    errors.first('inv_detail_list.' + index + '.fee_start_date')
                  }}
                </div>
              </td>
              <td valign="top">
                <a-date-picker
                  placeholder="Date To"
                  valueFormat="DD-MM-YYYY"
                  format="DD-MM-YYYY"
                  v-model="detail.fee_end_date"
                  style="width: 100%"
                />
                <div
                  class="validate"
                  v-if="
                    errors.has('inv_detail_list.' + index + '.fee_end_date')
                  "
                >
                  {{
                    errors.first('inv_detail_list.' + index + '.fee_end_date')
                  }}
                </div>
              </td>
              <td valign="top">
                <input
                  type="number"
                  min="1"
                  class="form-control"
                  v-model="detail.quantity"
                  @input="calculate"
                  :readonly="![5, 6].includes(detail.fee_type_id)"
                />
                <div
                  class="validate"
                  v-if="errors.has('inv_detail_list.' + index + '.quantity')"
                >
                  {{ errors.first('inv_detail_list.' + index + '.quantity') }}
                </div>
              </td>
              <td valign="top">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  v-model="detail.fee_amount"
                />
                <div
                  class="validate"
                  v-if="errors.has('inv_detail_list.' + index + '.fee_amount')"
                >
                  {{ errors.first('inv_detail_list.' + index + '.fee_amount') }}
                </div>
              </td>
              <td valign="top">
                <a-select
                  v-model="detail.discount_type"
                  style="width: 100%"
                  :options="[
                    { value: '$', label: '$' },
                    { value: '%', label: '%' }
                  ]"
                  @change="calculate"
                />
                <div
                  class="validate"
                  v-if="
                    errors.has('inv_detail_list.' + index + '.discount_type')
                  "
                >
                  {{
                    errors.first('inv_detail_list.' + index + '.discount_type')
                  }}
                </div>
              </td>
              <td valign="top">
                <input
                  v-model="detail.discount_rate"
                  type="number"
                  class="form-control"
                  @input="calculate"
                />
              </td>
              <td valign="top">
                <input
                  type="number"
                  class="form-control"
                  v-model="detail.vat_rate"
                  @input="calculate"
                />
              </td>
              <td valign="top">
                <input
                  readonly
                  type="number"
                  class="form-control"
                  v-model="detail.amount_include_vat"
                />
              </td>
              <td class="text-center" valign="top">
                <a
                  href="#"
                  class="text-red ts-mt-3"
                  @click.prevent="removeRow(detail)"
                >
                  <i class="fa fa-trash"></i>
                </a>
              </td>
            </tr>
            <tr class="bb">
              <td colspan="7" rowspan="6" valign="top" class="ts-text-right">
                <div style="width: 400px" class="ts-float-right ts-space-y-3">
                  <div class="ts-grid ts-grid-cols-3 ts-gap-3">
                    <div class="ts-flex ts-items-center ts-justify-end">
                      <label class="required ts-mr-2"
                        >{{ $t('invoice.paymentMethod') }} :</label
                      >
                    </div>
                    <div class="ts-col-span-2">
                      <select
                        class="form-control"
                        v-model="model.payment_method_id"
                        @change="onPaymentMethodChange"
                      >
                        <option value="">--select--</option>
                        <option
                          v-for="(p, index) in paymentMethods"
                          :key="index"
                          :value="p.id"
                          >{{ p.label }}</option
                        >
                      </select>
                      <div
                        class="validate"
                        v-if="errors.has('payment_method_id')"
                      >
                        {{ errors.first('payment_method_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="ts-grid ts-grid-cols-3 ts-gap-3">
                    <div class="ts-flex ts-items-center ts-justify-end">
                      <label
                        class="ts-mr-2"
                        :class="{ required: model.payment_method_id !== 1 }"
                        >{{ $t('invoice.bankName') }} :</label
                      >
                    </div>
                    <div class="ts-col-span-2">
                      <select
                        v-model="model.bank_id"
                        class="form-control"
                        :disabled="
                          model.payment_method_id == 1 ||
                            model.payment_method_id === '' ||
                            model.payment_method_id === null
                        "
                      >
                        <option
                          v-for="(b, index) in bank"
                          :value="b.bank_id"
                          :key="index"
                          >{{ b.bank_name }}</option
                        >
                      </select>
                      <div class="validate" v-if="errors.has('bank_id')">
                        {{ errors.first('bank_id') }}
                      </div>
                    </div>
                  </div>
                </div>
              </td>
              <td colspan="2" class="text-right">
                <strong>{{ $t('invoice.totalAmount') }} :</strong>
              </td>
              <td colspan="3">
                <input
                  :value="model.total_amount"
                  type="text"
                  class="form-control"
                  readonly
                />
                <div class="validate" v-if="errors.has('total_amount')">
                  {{ errors.first('total_amount') }}
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="text-right">
                <strong>{{ $t('invoice.fxRate') }} :</strong>
              </td>
              <td colspan="3">
                <input
                  :value="model.fx_rate"
                  type="number"
                  step="any"
                  class="form-control"
                  readonly
                />
              </td>
            </tr>
            <tr>
              <td colspan="2" class="text-right">
                <strong>{{ $t('invoice.paidInUsd') }} :</strong>
              </td>
              <td colspan="3">
                <div class="ts-flex ts-items-center">
                  <input
                    v-model.number="model.amount_paid_usd"
                    type="number"
                    step="any"
                    class="form-control"
                    @input="customerPaid"
                  />
                  <button
                    @click.prevent="convertToKhr"
                    class="ts-p-2 ts-bg-blue-600 ts-rounded ts-ml-1 ts-text-white ts-flex ts-items-center"
                  >
                    <i class="fas fa-arrow-down"></i>
                  </button>
                </div>
                <div class="validate" v-if="errors.has('amount_paid_usd')">
                  {{ errors.first('amount_paid_usd') }}
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="text-right">
                <strong>{{ $t('invoice.paidInKhr') }} :</strong>
              </td>
              <td colspan="3">
                <input v-model.number="model.amount_paid_khr" type="number" step="any" class="form-control"
                  @input="customerPaid" />
                <div class="validate" v-if="errors.has('amount_paid_khr')">
                  {{ errors.first('amount_paid_khr') }}
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="text-right">
                <strong>{{ $t('invoice.dueAmount') }} :</strong>
              </td>
              <td colspan="3">
                <input v-model.number="model.amount_due" type="number" step="any" class="form-control" readonly />
                <div class="validate" v-if="errors.has('amount_due')">
                  {{ errors.first('amount_due') }}
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="text-right">
                <strong>{{ $t('invoice.nextPaymentDate') }} :</strong>
              </td>
              <td colspan="3">
                <a-date-picker format="DD-MM-YYYY" valueFormat="DD-MM-YYYY"
                  v-model="model.next_payment_date" style="width: 100%" />
              </td>
            </tr>
            <!-- <tr v-if="this.model.inv_detail_list.length > 0">
              <td colspan="9" class="text-right">
                <strong>{{ $t('invoice.totalAmount') }} :</strong>
              </td>
              <td colspan="2">
                <input
                  v-model.number="model.amount_paid_khr"
                  type="number"
                  step="any"
                  class="form-control"
                  @input="customerPaid"
                />
                <div class="validate" v-if="errors.has('amount_paid_khr')">
                  {{ errors.first('amount_paid_khr') }}
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="text-right">
                <strong>{{ $t('invoice.dueAmount') }} :</strong>
              </td>
              <td colspan="3">
                <input
                  v-model.number="model.amount_due"
                  type="number"
                  step="any"
                  class="form-control"
                  readonly
                />
                <div class="validate" v-if="errors.has('amount_due')">
                  {{ errors.first('amount_due') }}
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="text-right">
                <strong>{{ $t('invoice.nextPaymentDate') }} :</strong>
              </td>
              <td colspan="3">
                <a-date-picker
                  :disabled="allowPickNewPaymentDate"
                  format="DD-MM-YYYY"
                  valueFormat="DD-MM-YYYY"
                  v-model="model.next_payment_date"
                  style="width: 100%"
                />
                <div class="validate" v-if="errors.has('next_payment_date')">
                  {{ errors.first('next_payment_date') }}
                </div>
              </td>
            </tr> -->
          </tbody>
        </table>
      </ts-loading-banner>
    </div>
  </div>
</template>

<script>
/**
 *  as request hidden qty column by bong borin
 *  calculate on start date to end date
 *
 */

import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import { Errors } from 'form-backend-validation'

export default {
  name: 'manualDetailCreate',
  props: ['value', 'validate', 'preDetails', 'loadingPreInv', 'bank'],
  data() {
    return {
      duration_in_month: null,
      model: {},
      newRow: {
        fee_type_id: null,
        fee_setup_id: null,
        fee_description: null,
        quantity: 1,
        fee_start_date: null,
        fee_end_date: null,
        payment_term_id: null,
        duration_in_month: null,
        fee_amount: 0,
        discount_type: '%',
        discount_rate: 0,
        discount_amount: 0,
        discount_reason: null,
        total_amount: 0,
        vat_rate: 0,
        vat_amount: 0,
        amount_include_vat: 0,
        ac_term_id: null,
        grade_id: null,
        shift_id: null,
        disabled: false, // just a variable to lock item from fee group
        duration_in_month_filter: null,
        pro_type_id: null // just a variable to lock item from fee group
      },
      exchange_rate: 0,
      exchanges: [],
      waiting: false,
      feeTypes: [],
      feeSetups: [],
      feeItemDetails: [],
      errors: new Errors(),
      promoTypes: [],
      paymentMethods: []
    }
  },
  created() {
    this.model = this.value
    this.addRow()
    this.fetchFeeType()
    this.exchangeRates()
    // this.fetchPromotion()   //user only asean
    this.getPaymentMethod()
  },
  computed: {
    ...mapState('invoice', [
      'room_type_id',
      'defaultCreditDay',
      'paymentTerms'
    ]),
    disableSelect() {
      return this.model.student_id != null
    },
    allowPickNewPaymentDate() {
      return !this.model.amount_due > 0
    },
    concatValue() {
      return this.model.student_id + this.model.grade_id + this.model.ac_term_id
    },
    feeSetupDetail: vm => row => {
      if (row) {
        let feeSetup = vm.feeSetups.filter(
          f => f.fee_type_id == row.fee_type_id
        )
        return feeSetup
      }

      return []
    },
    feeTypesList() {
      return this.feeTypes.filter(f => f.hidden === false)
    }
  },
  methods: {
    ...mapActions('invoice', [
      'getFeeType',
      'getSubscriptionService',
      'getFeeSetupDetail',
      'feeGroupDetail',
      'getPaymentTerm',
      'getFormViewModel',
      'getExchangeRate',
      'invoiceFormView'
    ]),
    addRow() {
      this.model.inv_detail_list.push(_.clone(this.newRow))
    },
    removeRow(row) {
      this.model.inv_detail_list.splice(
        this.model.inv_detail_list.indexOf(row),
        1
      )
      var findFeeGroupItem = this.model.inv_detail_list.filter(
        d => d.disabled == true
      )
      if (
        this.feeItemDetails[row.fee_type_id] != undefined &&
        row.disabled == true
      ) {
        delete this.feeItemDetails[row.fee_type_id]
      }
      if (!findFeeGroupItem.length > 0) {
        this.model.fee_group_id = null // set fee group to null when deleted all it's item
      }

      this.calculate()
    },
    // fetch fee type when component created
    async fetchFeeType() {
      this.waiting = true
      await this.getPaymentTerm()
      this.getFeeType({
        fields: {
          setup_payment_fee_types: 'fee_type_id,fee_type_name'
        },
        sort: '-fee_type_name',
        page: -1
      })
        .then(response => {
          this.feeTypes = response.data.map(el => ({
            value: el.fee_type_id,
            label: el.fee_type_name,
            hidden: false
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    // fetch fee setup detail when fee type change
    async fetchFeeSetupDetail(row, waiting = 0) {
      if (!this.feeItemDetails.hasOwnProperty(row.fee_type_id)) {
        this.waiting = !waiting ? true : ''
        let response = await this.getFeeSetupDetail({
          student_id: this.model.student_id,
          ac_term_id: this.model.ac_term_id,
          grade_id: this.model.grade_id,
          fee_type_id: row.fee_type_id,
          invoice_date: this.model.inv_date,
          room_type_id: this.room_type_id ? this.room_type_id : 1,
          inv_id: this.model.pre_inv_id
        })
        this.waiting = !waiting ? false : ''
        if (waiting == 0) {
          this.clearRow(row)
        }
        this.feeItemDetails = Object.assign(
          {},
          this.feeItemDetails,
          response.data
        ) // store temporary fee item detail when change fee type
        this.pushNewValueFeeSetup(Object.values(response.data).flat())

        // remove tuition fee and item detail, if get empty array from function
        if (response.data.length === 0) {
          const ftype = this.feeTypes.find(f => f.value === row.fee_type_id)
          if (ftype !== undefined) {
            ftype.hidden = true
            this.model.inv_detail_list = this.model.inv_detail_list.filter(
              fs => fs.fee_type_id !== row.fee_type_id
            )
            // Remove items with matching fee_type_id from feeSetups
            this.feeSetups = this.feeSetups.filter(
              fs => fs.fee_type_id !== row.fee_type_id
            )
            delete this.feeItemDetails[row.fee_type_id]
          }
        }
      }
    },
    // set value to each column in details
    onFeeSetupChange(item) {
      const itemDetails = this.feeItemDetails[item.fee_type_id]
      if (itemDetails !== undefined) {
        itemDetails
          .filter(f => f.fee_setup_id == item.fee_setup_id)
          .forEach(el => {
            if (!this.model.remark) {
              this.model.remark = el.discount_remark
            }
            item.fee_description = el.fee_name // description is a fee name
            item.quantity = 1
            item.fee_start_date = el.fee_start_date
              ? moment(el.fee_start_date, 'DD-MM-YYYY').format('DD-MM-YYYY')
              : null
            item.fee_end_date = el.fee_end_date
              ? moment(el.fee_end_date, 'DD-MM-YYYY').format('DD-MM-YYYY')
              : null
            item.payment_term_id = el.payment_term_id
            item.duration_in_month = el.duration_in_month
            item.fee_amount = el.fee_amount
            item.discount_rate = el.discount_rate
            item.discount_reason = el.discount_remark
              ? el.discount_remark
              : null
            item.ac_term_id = el.ac_term_id
            item.grade_id = el.grade_id
            item.shift_id = el.shift_id

            if (item.fee_type_id == 1) {
              // set promotion type id only tuition fee
              item.pro_type_id = el.pro_type_id
                ? parseInt(el.pro_type_id)
                : null

              // just show expired date to user if have promotion
              this.model.promtion_expired_date = el.promotion_expiry_date
                ? moment(el.promotion_expiry_date, 'DD-MM-YYYY')
                : null
            }
          })

        this.calculate()
      }
    },
    // push a new value to be select on fee name
    pushNewValueFeeSetup(value) {
      value
        .filter(v => v.fee_setup_id > 0)
        .forEach(el => {
          if (
            !this.feeSetups.filter(f => f.value == el.fee_setup_id).length > 0
          ) {
            this.feeSetups.push({
              fee_type_id: el.fee_type_id,
              value: el.fee_setup_id,
              label: el.fee_name,
              duration_in_month: parseInt(el.duration_in_month)
            })
          }
        })
    },
    // fetch subscription service by student
    async fetchSubscriptionService() {
      this.waiting = true
      await this.getSubscriptionService({
        student_id: this.model.student_id,
        ac_term_id: this.model.ac_term_id,
        grade_id: this.model.grade_id,
        inv_date: this.model.inv_date,
        room_type_id: this.room_type_id
      })
        .then(response => {
          this.pushNewValueFeeSetup(Object.values(response).flat())
          this.createRecordFromSubscription(Object.values(response).flat())
        })
        .catch(error => {
          this.$toasted.error(
            error.message + Object.values(error.errors).toString()
          )
        })
    },
    // create item list detail after fetch subscription service
    async createRecordFromSubscription(data) {
      this.model.inv_detail_list = []
      this.waiting = true
      await Promise.all(
        data.map(async el => {
          if (el.fee_setup_id) {
            var row = _.clone(this.newRow)
            row.fee_type_id = el.fee_type_id
            row.fee_amount = parseFloat(el.fee_amount)
            row.fee_setup_id = el.fee_setup_id
            const rowDetail = this.model.inv_detail_list.filter(
              d => d.fee_type_id == row.fee_type_id
            ).length

            if (rowDetail == 0) {
              if (
                this.model.inv_detail_list.filter(
                  f => f.fee_type_id == el.fee_type_id
                ).length == 0
              ) {
                this.model.inv_detail_list.push(row)
                await this.fetchFeeSetupDetail(row, 1)
                this.onFeeSetupChange(row)
              }
            }
          }
        })
      )
      this.waiting = false
    },
    // fetch fee group detail when clik on fee group list
    fetchFeeGroupDetail() {
      this.waiting = true
      this.feeGroupDetail({
        student_id: this.model.student_id,
        ac_term_id: this.model.ac_term_id,
        fee_group_id: this.model.fee_group_id,
        grade_id: this.model.grade_id,
        inv_date: this.model.inv_date
      })
        .then(response => {
          this.createRecordDetailFromFeeGroup(response.data)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    // create record detail when user click on free group
    createRecordDetailFromFeeGroup(details) {
      this.model.pre_inv_id = 0
      this.model.inv_detail_list = []
      // push a new value to be select on fee name
      this.pushNewValueFeeSetup(Object.values(details).flat())
      // create a temporary fee setup detail items
      this.feeItemDetails = Object.assign({}, details)
      // set new value to each columns in row details
      Object.values(details)
        .flat()
        .map(el => {
          var row = _.clone(this.newRow)
          row.fee_type_id = el.fee_type_id
          row.fee_setup_id = el.fee_setup_id
          row.disabled = true
          this.model.inv_detail_list.push(row)
          this.onFeeSetupChange(row)
        })
    },
    async createRecordDetailFromPreInvoice(data) {
      this.model.fee_group_id = null
      this.model.inv_detail_list = []
      this.feeTypes.forEach(el => (el.hidden = false))
      // push a new value to be select on fee name
      this.feeSetups = []

      //re-create a termporary fee setup detail items
      this.feeItemDetails = {}

      // set new value to each columns in row details
      await Promise.all(
        Object.values(data)
          .flat()
          .map(async el => {
            var row = _.clone(this.newRow)
            row.fee_type_id = el.fee_type_id
            row.fee_setup_id = el.fee_setup_id
            row.discount_type = el.discount_type
            row.disabled = true
            this.model.inv_detail_list.push(row)
            await this.fetchFeeSetupDetail(row, 1)
            this.onFeeSetupChange(row)
          })
      )
      this.waiting = false
    },
    customerPaid() {
      this.model.amount_paid =
        this.model.amount_paid_usd +
        (this.model.amount_paid_khr > 0
          ? this.model.amount_paid_khr / this.model.fx_rate
          : 0)
      this.model.amount_due = _.round(
        this.model.total_amount - this.model.amount_paid,
        2
      )
      this.model.next_payment_date = null
    },
    convertToKhr() {
      this.model.amount_paid_khr =
        (this.model.total_amount - this.model.amount_paid) * this.model.fx_rate
      this.model.amount_due = 0
      this.model.next_payment_date = null
    },
    // calculate invoice amount
    calculate() {
      var price = 0
      if (this.model.inv_detail_list.length > 0) {
        this.model.inv_detail_list.forEach(detail => {
          detail.quantity = detail.quantity ? detail.quantity : 1
          price = detail.fee_amount ? detail.fee_amount * detail.quantity : 0
          if (detail.discount_type == '%') {
            detail.discount_amount = detail.discount_rate
              ? price * _.round(detail.discount_rate / 100, 4)
              : 0
          }
          if (detail.discount_type == '$') {
            detail.discount_amount = detail.discount_rate
          }
          detail.total_amount = price - detail.discount_amount
          detail.vat_amount = detail.vat_rate
            ? detail.total_amount * _.round(detail.vat_rate / 100, 4)
            : 0
          detail.amount_include_vat = _.round(
            detail.total_amount + detail.vat_amount,
            2
          )
        })

        let sumAmountIncludeVat = _.sumBy(
          this.model.inv_detail_list,
          'amount_include_vat'
        )
        this.model.total_amount = sumAmountIncludeVat
        this.model.amount_paid_usd = this.model.total_amount
        ;(this.model.amount_paid_khr = 0),
          (this.model.amount_paid =
            this.model.amount_paid_usd +
            (this.model.amount_paid_khr > 0
              ? this.model.amount_paid_khr / this.model.fx_rate
              : 0))
        this.model.amount_due = _.round(
          this.model.total_amount - this.model.amount_paid,
          2
        )
      } else {
        this.model.total_amount = 0
        this.model.amount_paid = 0
        this.model.amount_paid_usd = 0
        this.model.amount_paid_khr = 0
        this.model.amount_due = 0
        this.model.next_payment_date = null
      }
    },
    // set each row to default by fee type change
    clearRow(row) {
      row.fee_setup_id = null
      row.fee_description = ''
      row.quantity = 1
      row.fee_start_date = null
      row.fee_end_date = null
      row.payment_term_id = null
      row.duration_in_month = null
      row.fee_amount = 0
      row.discount_rate = 0
      row.discount_amount = 0
      row.discount_reason = null
      row.total_amount = 0
      row.vat_rate = 0
      row.vat_amount = 0
      row.amount_include_vat = 0
      row.ac_term_id = null
      row.grade_id = null
      row.shift_id = null
      row.pro_type_id = null
    },
    async onPaymentMethodChange() {
      if (
        this.model.payment_method_id == 1 ||
        this.model.payment_method_id == ''
      ) {
        this.model.bank_id = null
      } else {
        var b = this.bank.find(b => parseInt(b.is_default) == 1)
        if (b !== undefined) {
          this.model.bank_id = b.bank_id
        }
      }
    },
    exchangeRates() {
      this.getExchangeRate().then(response => {
        this.model.fx_rate = response.exchange_rate
      })
    },
    getPaymentMethod() {
      this.invoiceFormView({
        fnName: 'paymentMethod'
      })
        .then(({ data }) => {
          this.paymentMethods = data.paymentMethod
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    }
  },
  watch: {
    // watch sub program because some student the same id but difference acps
    'model.acps_id': function() {
      this.feeItemDetails = [] // clear this if student change cuz it can be other fee setup difference
      this.feeSetups = [] // clear this because fee setup difference base on acps or term
    },
    loadingPreInv: function(value) {
      if (value) {
        this.waiting = value
      }
    },
    'model.student_id': function(id) {
      if (id && this.model.pre_inv_id == 0) {
        this.feeItemDetails = [] // clear this if student change cuz it can be other fee setup difference
        this.model.total_amount = 0
        this.model.amount_paid = 0
        this.model.amount_paid_khr = 0
        this.model.due_amount = 0
        this.model.remark = null
        // this.fetchSubscriptionService()
      }
      this.feeTypes.forEach(el => (el.hidden = false))
    },
    'model.ac_term_id': function(id) {
      if (id && this.model.pre_inv_id == 0) {
        this.feeItemDetails = [] // clear this if student change cuz it can be other fee setup difference
        this.feeSetups = [] // clear this becasue fee setup may difference by grade
        this.model.total_amount = 0
        this.model.amount_paid = 0
        this.model.amount_paid_khr = 0
        this.model.due_amount = 0
        // this.fetchSubscriptionService()
      }
    },
    'model.grade_id': function(id) {
      if (id && this.model.pre_inv_id == 0) {
        this.feeItemDetails = [] // clear this if student change cuz it can be other fee setup difference
        this.feeSetups = [] // clear this becasue fee setup may difference by grade
        this.model.total_amount = 0
        this.model.amount_paid = 0
        this.model.amount_paid_khr = 0
        this.model.due_amount = 0
        this.model.remark = null
      }
    },
    'model.fee_group_id': function(id) {
      if (id) {
        this.feeSetups = []
        this.fetchFeeGroupDetail()
      }
    },
    'model.inv_detail_list': function(values) {
      if (!values.length > 0 && this.model.pre_inv_id == 0) {
        // clear this after created record successfully
        this.feeItemDetails = []
      }
    },
    concatValue: function(value) {
      if (value && !this.model.pre_inv_id) {
        this.fetchSubscriptionService()
      }
    },
    preDetails: {
      handler(data) {
        if (Object.values(data).length > 0) {
          this.createRecordDetailFromPreInvoice(data)
        }
      },
      deep: true
    },
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style lang="css" scoped>
* {
  font-size: 12px !important;
}

#table-details>thead>tr>th {
  padding: 5px 4px;
  background: #f2f3f4;
}

#table-details>tbody>tr>td {
  padding: 5px 4px;
  border: none !important;
  font-size: 12px !important;
}

.only-border-bottom {
  border-top: none;
  border-left: none;
  border-right: none;
}
</style>
